import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import {
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiCalendar,
} from "react-icons/fi";
function EditCgp({
  backUrl,
  api,
  fetchData,
  getType,
  getPP,
  getTypePersonne,
  getPM,
  getTeteReseau,
  getTaux,
  getModele,
  getCodeInvest,
  getTypeProduction,
  getAnnee,
  getSecteurActivite,
  getValue,
  getContact,
  getSociete,
  getSituationMatrimonial,
  //render
  renderSocieteOptions,
  renderContactOptions,
  renderOuiNonOptions,
  renderPmOptions,
  renderTauxOptions,
  renderTeteReseauOptions,
  renderTypePersonneOptions,
  renderPpOptions,
  renderModeleOptions,
  renderTypeOptions,
  renderCodeOptions,
  renderTypeProductionOptions,
  renderSecteurActiviteOptions,
  renderSituationMatrimonialOptions,

  // handle
  handleCodeChange,
  handleActifChange,
  handleTauxChange,
  handleTypeChange,
  handleTypePersonneChange,
  handleDefautChange,
  handleCompteCreanceChange,
  handleTrigrammeChange,
  handlePersonneChange,
  handlePmChange,
  handleNumeroChange,
  handleTeteReseauChange,
  handleEntrepreteurChange,
  handleModeleChange,
  handleModeleTChange,
  handleOrigineChange,
  handleEmailDeContactChange,
  handleCodeInvesChange,
  handleSocieteChange,
  //exploitant
  handleComptableChange,
  handleDataCreaChange,
  handleDateEntreeChange,
  handleImpactChange,
  handleMatChange,
  handleSecteurChange,
  handleSecteurActiviteChange,
  handleSurfaceConsChange,
  handleSurfaceExpChange,
  handleSurfaceTotChange,
  handleTypeProductionChange,
  formDonneesFinanciere,
  onAddFormDonneesFinanciere,
  onDeleteFormDonneesFinanciere,
  renderAnneeOptions,
  handleInputFinanceChange,
  formDonneesInvest,
  onAddFormDonneesInvest,
  onDeleteFormDonneesInvest,
  handleInputInvestChange,

  // requete
  handleSubmitP,
  handleSubmitPm,
  //variables
  selectedTaux,
  selectedActif,
  selectedCode,
  debounceCode,
  selectedCompteCreance,
  selectedDefaut,
  selectedEntrepreteur,
  selectedModele,
  selectedModeleT,
  selectedNumero,
  selectedOrigine,
  selectedEmailDeContact,
  selectedPersonnePhysique,
  selectedPm,
  selectedTeteReseau,
  selectedTrigramme,
  selectedType,
  selectedTypePersonne,
  // exploitant
  selectedComptable,
  selectedDataCrea,
  selectedDateEntree,
  selectedImpact,
  selectedMat,
  selectedSecteur,
  selectedSecteurActivite,
  selectedSurfaceCons,
  selectedSurfaceExp,
  selectedSurfaceTot,
  selectedTypeProduction,
  //Direction produit
  selectedCodeInves,
  // variable données
  IdentificationData,
  DonneesComplementData,
  DonneesComplementDirectionData,
  DonneesComplementExploitantData,
  hmfData1,
  hmfData2,
  value,
  setValue,
  value1,
  setValue1,
  // custom
  CustomNavTabs,
  activeTab,
  Titre,
  TitrePage,
  // modal
  getTitre,
  getPay,
  handleSave,
  handleSave1,
  titreId,
  nom,
  prenom,
  dateDeNaissance,
  villeDeNaissance,
  ville,
  ville1,
  departementOuPays,
  profession,
  adresse,
  adresse1,
  complement,
  codePostal,
  codePostal1,
  payId,
  payId1,
  telFix,
  telMobil,
  emailPro,
  emailPerso,
  email,
  fax,
  telephone,
  raisonSociale,
  setPayId,
  handlePayIdChange,
  renderPaysOptions,
  renderTitreOptions,
  modalOpen,
  modalOpen1,
  toggleModal,
  toggleModal1,
  handleTitreIdChange,
  setRaisonSociale,
  setEmail,
  setEmailPro,
  handleSituationMatrimonialChange,
  setEmailPerso,
  setNom,
  setTelephone,
  setFax,
  setAdresse,
  setAdresse1,
  setCodePostal,
  setCodePostal1,
  setVille,
  setVille1,
  setPrenom,
  setDateDeNaissance,
  setVilleDeNaissance,
  setDepartementOuPays,
  setProfession,
  setComplement,
  setTelFix,
  setTelMobil,
  forceRender,
  forceRender1,
  forceRender2,
  forceRender3,
}) {
  const { id } = useParams();
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    //minWidth: "1em",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  // État pour le collapse
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);

  // Fonction toggle
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };

  // État pour le collapse
  const [
    isDonneesComplementAccordionOpen,
    setIsDonneesComplementAccordionOpen,
  ] = useState(true);

  // Fonction toggle
  const toggleDonneesComplementAccordion = () => {
    setIsDonneesComplementAccordionOpen(!isDonneesComplementAccordionOpen);
  };
  // État pour le collapse
  const [isDonneesDirectionAccordionOpen, setIsDonneesDirectionAccordionOpen] =
    useState(true);

  // Fonction toggle
  const toggleDonneesDirectionAccordion = () => {
    setIsDonneesDirectionAccordionOpen(!isDonneesDirectionAccordionOpen);
  };
  // État pour le collapse
  const [
    isDonneesExploitantAccordionOpen,
    setIsDonneesExploitantAccordionOpen,
  ] = useState(true);

  // Fonction toggle
  const toggleDonneesExploitantAccordion = () => {
    setIsDonneesExploitantAccordionOpen(!isDonneesExploitantAccordionOpen);
  };
  // État pour le collapse
  const [
    isDonneesFinanciereAccordionOpen,
    setIsDonneesFinanciereAccordionOpen,
  ] = useState(true);

  // Fonction toggle
  const toggleDonneesFinanciereAccordion = () => {
    setIsDonneesFinanciereAccordionOpen(!isDonneesFinanciereAccordionOpen);
  };
  // État pour le collapse
  const [isDonneesInvestAccordionOpen, setIsDonneesInvestAccordionOpen] =
    useState(true);

  // Fonction toggle
  const toggleDonneesInvestAccordion = () => {
    setIsDonneesInvestAccordionOpen(!isDonneesInvestAccordionOpen);
  };

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
      marginTop: "-8px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "#fff", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        await fetchData();
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataAsync();
  }, []);

  useEffect(() => {
    if (!loading) {
      getType();
      getContact();
      getTypePersonne();
      // getPM();
      getPP();
      getTeteReseau();
      getTaux();
      getModele();
      getCodeInvest();
      getTypeProduction();
      getAnnee();
      getTitre();
      getPay();
      getSecteurActivite();
      getSociete();
      getSituationMatrimonial();
    }
  }, [loading]);

  useEffect(() => {
    if (value?.length > 1) {
      getPP(value);
    }
  }, [loading, value]);
  useEffect(() => {
    if (value1?.length > 1) {
      getPM(value1);
    }
  }, [loading, value1]);
  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/${api}/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {TitrePage}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          Titre
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={
                            selectedTypePersonne?.label == "PP"
                              ? handleSubmitP
                              : handleSubmitPm
                          }
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleIdentificationAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Identification
                                      </span>
                                    </div>
                                    {isIdentificationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isIdentificationAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(IdentificationData).map(
                                          ([key, value], index) => (
                                            <React.Fragment key={index}>
                                              {/* Type* */}
                                              {key === "Type" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Type
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Type"
                                                        value={
                                                          selectedType?.label ==
                                                          null
                                                            ? null
                                                            : selectedType
                                                        }
                                                        onChange={
                                                          handleTypeChange
                                                        }
                                                        options={renderTypeOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedType == null
                                                        )}
                                                        isDisabled={
                                                          type_compte ===
                                                          "partenaire_premium"
                                                        }
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                      {selectedType ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Type ne peut pas être
                                                          vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Personne Physique* (quand PP sélectionné) */}
                                              {key === "Personne Physique" &&
                                                selectedTypePersonne?.label ==
                                                  "PP" && (
                                                  <div
                                                    className="field-item px-2 py-1"
                                                    style={{
                                                      backgroundColor: "white",
                                                      transition:
                                                        "all 0.15s ease",
                                                      borderLeft:
                                                        "3px solid #dc3545",
                                                      marginBottom: "1px",
                                                      position: "relative",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffe6e6";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#dc3545";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "white";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#dc3545";
                                                    }}
                                                  >
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            Personne Physique
                                                          </span>
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        className="d-flex align-items-center"
                                                      >
                                                        <Select
                                                          key={forceRender2}
                                                          onInputChange={
                                                            setValue
                                                          }
                                                          value={
                                                            selectedPersonnePhysique?.label ==
                                                            null
                                                              ? null
                                                              : selectedPersonnePhysique
                                                          }
                                                          placeholder="Taper pour rechercher ..."
                                                          onChange={
                                                            handlePersonneChange
                                                          }
                                                          options={renderPpOptions()}
                                                          isClearable={true}
                                                          classNamePrefix="select2-selection"
                                                          styles={styles(
                                                            selectedPersonnePhysique ===
                                                              null
                                                          )}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                          className="flex-grow-1"
                                                        />
                                                        {type_compte !=
                                                          "partenaire_premium" && (
                                                          <Button
                                                            onClick={
                                                              toggleModal1
                                                            }
                                                            className="btn btn-sm btn-light ms-2"
                                                          >
                                                            +
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                    {selectedPersonnePhysique ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Personne physique ne
                                                        peut pas être vide
                                                      </div>
                                                    )}

                                                    {/* Modal Personne Physique */}
                                                    <Modal
                                                      isOpen={modalOpen1}
                                                      toggle={toggleModal1}
                                                    >
                                                      <ModalHeader
                                                        toggle={toggleModal1}
                                                      >
                                                        Ajouter une nouvelle
                                                        personne physique
                                                      </ModalHeader>
                                                      <ModalBody>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>Nom</label>
                                                            <input
                                                              type="text"
                                                              value={nom}
                                                              onChange={(e) =>
                                                                setNom(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Prénom
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={prenom}
                                                              onChange={(e) =>
                                                                setPrenom(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>Titre</label>
                                                            <Select
                                                              placeholder="Selectionner un titre"
                                                              defaultValue={
                                                                titreId?.label ==
                                                                null
                                                                  ? null
                                                                  : titreId
                                                              }
                                                              onChange={
                                                                handleTitreIdChange
                                                              }
                                                              options={renderTitreOptions()}
                                                              isClearable={true}
                                                              className="select2 flex-grow-1"
                                                              styles={{
                                                                menu: (
                                                                  provided,
                                                                  state
                                                                ) => ({
                                                                  ...provided,
                                                                  backgroundColor:
                                                                    "white",
                                                                }),
                                                              }}
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Société
                                                            </label>
                                                            <Select
                                                              placeholder="Selectionner une societe"
                                                              defaultValue={
                                                                titreId?.label ==
                                                                null
                                                                  ? null
                                                                  : titreId
                                                              }
                                                              onChange={
                                                                handleSocieteChange
                                                              }
                                                              options={renderSocieteOptions()}
                                                              isClearable={true}
                                                              className="select2 flex-grow-1"
                                                              styles={{
                                                                menu: (
                                                                  provided,
                                                                  state
                                                                ) => ({
                                                                  ...provided,
                                                                  backgroundColor:
                                                                    "white",
                                                                }),
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Date de naissance
                                                            </label>
                                                            <InputMask
                                                              mask="99/99/9999"
                                                              value={
                                                                dateDeNaissance
                                                              }
                                                              onChange={(e) =>
                                                                setDateDeNaissance(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                              placeholder="JJ/MM/AAAA"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Ville de naissance
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={
                                                                villeDeNaissance
                                                              }
                                                              onChange={(e) =>
                                                                setVilleDeNaissance(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Departement de
                                                              naissance
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={
                                                                departementOuPays
                                                              }
                                                              onChange={(e) =>
                                                                setDepartementOuPays(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Profession
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={profession}
                                                              onChange={(e) =>
                                                                setProfession(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Situation
                                                              matrimoniale
                                                            </label>
                                                            <Select
                                                              placeholder="Selectionner situtation matrimoniale"
                                                              defaultValue={
                                                                titreId?.label ==
                                                                null
                                                                  ? null
                                                                  : titreId
                                                              }
                                                              onChange={
                                                                handleSituationMatrimonialChange
                                                              }
                                                              options={renderSituationMatrimonialOptions()}
                                                              isClearable={true}
                                                              className="select2 flex-grow-1"
                                                              styles={{
                                                                menu: (
                                                                  provided,
                                                                  state
                                                                ) => ({
                                                                  ...provided,
                                                                  backgroundColor:
                                                                    "white",
                                                                }),
                                                              }}
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Adresse
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={adresse1}
                                                              onChange={(e) =>
                                                                setAdresse1(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Complément
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={complement}
                                                              onChange={(e) =>
                                                                setComplement(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Code postal
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={
                                                                codePostal1
                                                              }
                                                              onChange={(e) =>
                                                                setCodePostal1(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>Ville</label>
                                                            <input
                                                              type="text"
                                                              value={ville1}
                                                              onChange={(e) =>
                                                                setVille1(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>Pays</label>
                                                            <Select
                                                              placeholder="Sélectionner un pays"
                                                              defaultValue={
                                                                payId1?.label ==
                                                                null
                                                                  ? null
                                                                  : payId1
                                                              }
                                                              onChange={
                                                                handlePayIdChange
                                                              }
                                                              options={renderPaysOptions()}
                                                              styles={{
                                                                menu: (
                                                                  provided,
                                                                  state
                                                                ) => ({
                                                                  ...provided,
                                                                  backgroundColor:
                                                                    "white",
                                                                }),
                                                              }}
                                                              isClearable={true}
                                                              className="select2"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Email
                                                              professionnel
                                                            </label>
                                                            <input
                                                              type="email"
                                                              value={emailPro}
                                                              onChange={(e) =>
                                                                setEmailPro(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Email perso
                                                            </label>
                                                            <input
                                                              type="email"
                                                              value={emailPerso}
                                                              onChange={(e) =>
                                                                setEmailPerso(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                            {emailPerso?.trim() ===
                                                              "" && (
                                                              <div
                                                                style={{
                                                                  color: "red",
                                                                  fontSize:
                                                                    "12px",
                                                                  marginTop:
                                                                    "5px",
                                                                }}
                                                              >
                                                                Ce champ est
                                                                obligatoire.
                                                              </div>
                                                            )}
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Téléphone mobile
                                                            </label>
                                                            <input
                                                              type="tel"
                                                              value={telMobil}
                                                              onChange={(e) =>
                                                                setTelMobil(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                              required
                                                            />
                                                            {telMobil?.trim() ===
                                                              "" && (
                                                              <div
                                                                style={{
                                                                  color: "red",
                                                                  fontSize:
                                                                    "12px",
                                                                  marginTop:
                                                                    "5px",
                                                                }}
                                                              >
                                                                Ce champ est
                                                                obligatoire.
                                                              </div>
                                                            )}
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Téléphone fixe
                                                            </label>
                                                            <input
                                                              type="tel"
                                                              value={telFix}
                                                              onChange={(e) =>
                                                                setTelFix(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </ModalBody>
                                                      <ModalFooter>
                                                        <Button
                                                          color="primary"
                                                          onClick={handleSave1}
                                                        >
                                                          Enregistrer
                                                        </Button>
                                                        <Button
                                                          color="secondary"
                                                          onClick={toggleModal1}
                                                        >
                                                          Annuler
                                                        </Button>
                                                      </ModalFooter>
                                                    </Modal>
                                                  </div>
                                                )}

                                              {/* Personne Morale* (quand PM sélectionné) */}
                                              {((key === "Personne Morale" &&
                                                selectedTypePersonne?.label ==
                                                  "PM") ||
                                                (key === "Personne Morale" &&
                                                  selectedTypePersonne?.label !=
                                                    "PM" &&
                                                  selectedTypePersonne?.label !=
                                                    "PP")) && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Personne Morale
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={8}
                                                      className="d-flex align-items-center"
                                                    >
                                                      <Select
                                                        key={forceRender}
                                                        onInputChange={
                                                          setValue1
                                                        }
                                                        placeholder="Taper pour rechercher ..."
                                                        value={
                                                          selectedPm?.label ==
                                                          null
                                                            ? null
                                                            : selectedPm
                                                        }
                                                        onChange={
                                                          handlePmChange
                                                        }
                                                        options={renderPmOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedPm === null ||
                                                            selectedPm === ""
                                                        )}
                                                        isDisabled={
                                                          type_compte ===
                                                          "partenaire_premium"
                                                        }
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        className="flex-grow-1"
                                                      />
                                                      {type_compte !=
                                                        "partenaire_premium" && (
                                                        <Button
                                                          onClick={toggleModal}
                                                          className="btn btn-sm btn-light ms-2"
                                                        >
                                                          +
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                  {(selectedPm === null ||
                                                    selectedPm === "") && (
                                                    <div className="invalid-feedback d-block mt-1 small">
                                                      Personne Morale ne peut
                                                      pas être vide
                                                    </div>
                                                  )}

                                                  {/* Modal Personne Morale */}
                                                  <Modal
                                                    isOpen={modalOpen}
                                                    toggle={toggleModal}
                                                  >
                                                    <ModalHeader
                                                      toggle={toggleModal}
                                                    >
                                                      Ajouter une nouvelle
                                                      personne morale
                                                    </ModalHeader>
                                                    <ModalBody>
                                                      <FormGroup>
                                                        <Label for="raisonSociale">
                                                          Raison sociale
                                                        </Label>
                                                        <Input
                                                          type="text"
                                                          name="raisonSociale"
                                                          id="raisonSociale"
                                                          value={raisonSociale}
                                                          onChange={(e) =>
                                                            setRaisonSociale(
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <FormGroup>
                                                        <Label for="email">
                                                          Email
                                                        </Label>
                                                        <Input
                                                          type="email"
                                                          name="email"
                                                          id="email"
                                                          value={email}
                                                          onChange={(e) =>
                                                            setEmail(
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <FormGroup>
                                                        <Label for="telephone">
                                                          Téléphone
                                                        </Label>
                                                        <Input
                                                          type="text"
                                                          name="telephone"
                                                          id="telephone"
                                                          value={telephone}
                                                          onChange={(e) =>
                                                            setTelephone(
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <FormGroup>
                                                        <Label for="fax">
                                                          Fax
                                                        </Label>
                                                        <Input
                                                          type="text"
                                                          name="fax"
                                                          id="fax"
                                                          value={fax}
                                                          onChange={(e) =>
                                                            setFax(
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <FormGroup>
                                                        <Label for="adresse">
                                                          Adresse
                                                        </Label>
                                                        <Input
                                                          type="text"
                                                          name="adresse"
                                                          id="adresse"
                                                          value={adresse}
                                                          onChange={(e) =>
                                                            setAdresse(
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <FormGroup>
                                                        <Label for="codePostal">
                                                          Code postal
                                                        </Label>
                                                        <Input
                                                          type="text"
                                                          name="codePostal"
                                                          id="codePostal"
                                                          value={codePostal}
                                                          onChange={(e) =>
                                                            setCodePostal(
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <FormGroup>
                                                        <Label for="ville">
                                                          Ville
                                                        </Label>
                                                        <Input
                                                          type="text"
                                                          name="ville"
                                                          id="ville"
                                                          value={ville}
                                                          onChange={(e) =>
                                                            setVille(
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <FormGroup>
                                                        <Label for="payId">
                                                          Pays
                                                        </Label>
                                                        <Select
                                                          placeholder="Sélectionnez le pays"
                                                          defaultValue={
                                                            payId?.label == null
                                                              ? null
                                                              : payId
                                                          }
                                                          onChange={setPayId}
                                                          options={renderPaysOptions()}
                                                          styles={{
                                                            menu: (
                                                              provided,
                                                              state
                                                            ) => ({
                                                              ...provided,
                                                              backgroundColor:
                                                                "white",
                                                            }),
                                                          }}
                                                        />
                                                      </FormGroup>
                                                    </ModalBody>
                                                    <ModalFooter>
                                                      <Button
                                                        color="primary"
                                                        onClick={handleSave}
                                                      >
                                                        Enregistrer
                                                      </Button>
                                                      <Button
                                                        color="secondary"
                                                        onClick={toggleModal}
                                                      >
                                                        Annuler
                                                      </Button>
                                                    </ModalFooter>
                                                  </Modal>
                                                </div>
                                              )}

                                              {/* Personne Morale affiché mais PP sélectionné */}
                                              {key === "Personne Morale" &&
                                                selectedTypePersonne?.label ==
                                                  "PP" && (
                                                  <div
                                                    className="field-item px-2 py-1"
                                                    style={{
                                                      backgroundColor: "white",
                                                      transition:
                                                        "all 0.15s ease",
                                                      borderLeft:
                                                        "3px solid #dc3545",
                                                      marginBottom: "1px",
                                                      position: "relative",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffe6e6";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#dc3545";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "white";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#dc3545";
                                                    }}
                                                  >
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            Personne Physique
                                                          </span>
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        className="d-flex align-items-center"
                                                      >
                                                        <Select
                                                          key={forceRender1}
                                                          onInputChange={
                                                            setValue
                                                          }
                                                          value={
                                                            selectedPersonnePhysique?.label ==
                                                            null
                                                              ? null
                                                              : selectedPersonnePhysique
                                                          }
                                                          placeholder="Taper pour rechercher ..."
                                                          onChange={
                                                            handlePersonneChange
                                                          }
                                                          options={renderPpOptions()}
                                                          isClearable={true}
                                                          classNamePrefix="select2-selection"
                                                          styles={styles(false)}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                          className="flex-grow-1"
                                                        />
                                                        {type_compte !=
                                                          "partenaire_premium" && (
                                                          <Button
                                                            onClick={
                                                              toggleModal1
                                                            }
                                                            className="btn btn-sm btn-light ms-2"
                                                          >
                                                            +
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                    {selectedPersonnePhysique ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Personne physique ne
                                                        peut pas être vide
                                                      </div>
                                                    )}

                                                    {/* Modal Personne Physique (version simplifiée) */}
                                                    <Modal
                                                      isOpen={modalOpen1}
                                                      toggle={toggleModal1}
                                                    >
                                                      <ModalHeader
                                                        toggle={toggleModal1}
                                                      >
                                                        Ajouter une nouvelle
                                                        personne physique
                                                      </ModalHeader>
                                                      <ModalBody>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>Titre</label>
                                                            <Select
                                                              placeholder="Selectionner un titre"
                                                              defaultValue={
                                                                titreId?.label ==
                                                                null
                                                                  ? null
                                                                  : titreId
                                                              }
                                                              onChange={
                                                                handleTitreIdChange
                                                              }
                                                              options={renderTitreOptions()}
                                                              isClearable={true}
                                                              className="select2 flex-grow-1"
                                                              styles={{
                                                                menu: (
                                                                  provided,
                                                                  state
                                                                ) => ({
                                                                  ...provided,
                                                                  backgroundColor:
                                                                    "white",
                                                                }),
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>Nom</label>
                                                            <input
                                                              type="text"
                                                              value={nom}
                                                              onChange={(e) =>
                                                                setNom(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Prénom
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={prenom}
                                                              onChange={(e) =>
                                                                setPrenom(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Date de naissance
                                                            </label>
                                                            <InputMask
                                                              mask="99/99/9999"
                                                              value={
                                                                dateDeNaissance
                                                              }
                                                              onChange={(e) =>
                                                                setDateDeNaissance(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                              placeholder="JJ/MM/AAAA"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Ville de naissance
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={
                                                                villeDeNaissance
                                                              }
                                                              onChange={(e) =>
                                                                setVilleDeNaissance(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Departement ou
                                                              Pays
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={
                                                                departementOuPays
                                                              }
                                                              onChange={(e) =>
                                                                setDepartementOuPays(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Profession
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={profession}
                                                              onChange={(e) =>
                                                                setProfession(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Adresse
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={adresse1}
                                                              onChange={(e) =>
                                                                setAdresse1(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Complément
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={complement}
                                                              onChange={(e) =>
                                                                setComplement(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Code postal
                                                            </label>
                                                            <input
                                                              type="text"
                                                              value={
                                                                codePostal1
                                                              }
                                                              onChange={(e) =>
                                                                setCodePostal1(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>Ville</label>
                                                            <input
                                                              type="text"
                                                              value={ville1}
                                                              onChange={(e) =>
                                                                setVille1(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>Pays</label>
                                                            <Select
                                                              placeholder="Sélectionner un pays"
                                                              defaultValue={
                                                                payId1?.label ==
                                                                null
                                                                  ? null
                                                                  : payId1
                                                              }
                                                              onChange={
                                                                handlePayIdChange
                                                              }
                                                              options={renderPaysOptions()}
                                                              styles={{
                                                                menu: (
                                                                  provided,
                                                                  state
                                                                ) => ({
                                                                  ...provided,
                                                                  backgroundColor:
                                                                    "white",
                                                                }),
                                                              }}
                                                              isClearable={true}
                                                              className="select2"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Téléphone fixe
                                                            </label>
                                                            <input
                                                              type="tel"
                                                              value={telFix}
                                                              onChange={(e) =>
                                                                setTelFix(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                          <Col md={6}>
                                                            <label>
                                                              Téléphone mobile
                                                            </label>
                                                            <input
                                                              type="tel"
                                                              value={telMobil}
                                                              onChange={(e) =>
                                                                setTelMobil(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                          <Col md={6}>
                                                            <label>
                                                              Email
                                                              professionnel
                                                            </label>
                                                            <input
                                                              type="email"
                                                              value={emailPro}
                                                              onChange={(e) =>
                                                                setEmailPro(
                                                                  e.target.value
                                                                )
                                                              }
                                                              className="form-control form-control-sm"
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </ModalBody>
                                                      <ModalFooter>
                                                        <Button
                                                          color="primary"
                                                          onClick={handleSave1}
                                                        >
                                                          Enregistrer
                                                        </Button>
                                                        <Button
                                                          color="secondary"
                                                          onClick={toggleModal1}
                                                        >
                                                          Annuler
                                                        </Button>
                                                      </ModalFooter>
                                                    </Modal>
                                                  </div>
                                                )}

                                              {/* Personne Physique affiché mais PM sélectionné */}
                                              {key === "Personne Physique" &&
                                                selectedTypePersonne?.label ==
                                                  "PM" && (
                                                  <div
                                                    className="field-item px-2 py-1"
                                                    style={{
                                                      backgroundColor: "white",
                                                      transition:
                                                        "all 0.15s ease",
                                                      borderLeft:
                                                        "3px solid #dc3545",
                                                      marginBottom: "1px",
                                                      position: "relative",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffe6e6";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#dc3545";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "white";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#dc3545";
                                                    }}
                                                  >
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            Personne Morale
                                                          </span>
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        className="d-flex align-items-center"
                                                      >
                                                        <Select
                                                          key={forceRender}
                                                          onInputChange={
                                                            setValue1
                                                          }
                                                          placeholder="Taper pour rechercher ..."
                                                          value={
                                                            selectedPm?.label ==
                                                            null
                                                              ? null
                                                              : selectedPm
                                                          }
                                                          onChange={
                                                            handlePmChange
                                                          }
                                                          options={renderPmOptions()}
                                                          isClearable={true}
                                                          classNamePrefix="select2-selection"
                                                          styles={styles(false)}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                          className="flex-grow-1"
                                                        />
                                                        {type_compte !=
                                                          "partenaire_premium" && (
                                                          <Button
                                                            onClick={
                                                              toggleModal
                                                            }
                                                            className="btn btn-sm btn-light ms-2"
                                                          >
                                                            +
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                    {(selectedPm === null ||
                                                      selectedPm === "") && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Personne Morale ne peut
                                                        pas être vide
                                                      </div>
                                                    )}

                                                    {/* Modal Personne Morale */}
                                                    <Modal
                                                      isOpen={modalOpen}
                                                      toggle={toggleModal}
                                                    >
                                                      <ModalHeader
                                                        toggle={toggleModal}
                                                      >
                                                        Ajouter une nouvelle
                                                        personne morale
                                                      </ModalHeader>
                                                      <ModalBody>
                                                        <FormGroup>
                                                          <Label for="raisonSociale">
                                                            Raison sociale
                                                          </Label>
                                                          <Input
                                                            type="text"
                                                            name="raisonSociale"
                                                            id="raisonSociale"
                                                            value={
                                                              raisonSociale
                                                            }
                                                            onChange={(e) =>
                                                              setRaisonSociale(
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </FormGroup>
                                                        <FormGroup>
                                                          <Label for="email">
                                                            Email
                                                          </Label>
                                                          <Input
                                                            type="email"
                                                            name="email"
                                                            id="email"
                                                            value={email}
                                                            onChange={(e) =>
                                                              setEmail(
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </FormGroup>
                                                        <FormGroup>
                                                          <Label for="telephone">
                                                            Téléphone
                                                          </Label>
                                                          <Input
                                                            type="text"
                                                            name="telephone"
                                                            id="telephone"
                                                            value={telephone}
                                                            onChange={(e) =>
                                                              setTelephone(
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </FormGroup>
                                                        <FormGroup>
                                                          <Label for="fax">
                                                            Fax
                                                          </Label>
                                                          <Input
                                                            type="text"
                                                            name="fax"
                                                            id="fax"
                                                            value={fax}
                                                            onChange={(e) =>
                                                              setFax(
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </FormGroup>
                                                        <FormGroup>
                                                          <Label for="adresse">
                                                            Adresse
                                                          </Label>
                                                          <Input
                                                            type="text"
                                                            name="adresse"
                                                            id="adresse"
                                                            value={adresse}
                                                            onChange={(e) =>
                                                              setAdresse(
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </FormGroup>
                                                        <FormGroup>
                                                          <Label for="codePostal">
                                                            Code postal
                                                          </Label>
                                                          <Input
                                                            type="text"
                                                            name="codePostal"
                                                            id="codePostal"
                                                            value={codePostal}
                                                            onChange={(e) =>
                                                              setCodePostal(
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </FormGroup>
                                                        <FormGroup>
                                                          <Label for="ville">
                                                            Ville
                                                          </Label>
                                                          <Input
                                                            type="text"
                                                            name="ville"
                                                            id="ville"
                                                            value={ville}
                                                            onChange={(e) =>
                                                              setVille(
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </FormGroup>
                                                        <FormGroup>
                                                          <Label for="payId">
                                                            Pays
                                                          </Label>
                                                          <Select
                                                            placeholder="Sélectionnez le pays"
                                                            defaultValue={
                                                              payId?.label ==
                                                              null
                                                                ? null
                                                                : payId
                                                            }
                                                            onChange={setPayId}
                                                            options={renderPaysOptions()}
                                                            styles={{
                                                              menu: (
                                                                provided,
                                                                state
                                                              ) => ({
                                                                ...provided,
                                                                backgroundColor:
                                                                  "white",
                                                              }),
                                                            }}
                                                          />
                                                        </FormGroup>
                                                      </ModalBody>
                                                      <ModalFooter>
                                                        <Button
                                                          color="primary"
                                                          onClick={handleSave}
                                                        >
                                                          Enregistrer
                                                        </Button>
                                                        <Button
                                                          color="secondary"
                                                          onClick={toggleModal}
                                                        >
                                                          Annuler
                                                        </Button>
                                                      </ModalFooter>
                                                    </Modal>
                                                  </div>
                                                )}

                                              {/* Type personne* */}
                                              {key === "Type personne" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Type personne
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Type personne"
                                                        value={
                                                          selectedTypePersonne?.label ==
                                                          null
                                                            ? null
                                                            : selectedTypePersonne
                                                        }
                                                        onChange={
                                                          handleTypePersonneChange
                                                        }
                                                        options={renderTypePersonneOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedTypePersonne ==
                                                            null
                                                        )}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                      {selectedTypePersonne ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Type personne ne peut
                                                          pas être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* N° RCS */}
                                              {key === "N° RCS" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          N° RCS
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedNumero}
                                                        required
                                                        onChange={
                                                          handleNumeroChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Code APE */}
                                              {key === "Code APE" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Code APE
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        key={forceRender2}
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedCode}
                                                        required
                                                        onChange={
                                                          handleCodeChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Date entrée en relation */}
                                              {key ===
                                                "Date entrée en relation" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Date entrée en
                                                          relation
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <div className="input-wrapper position-relative">
                                                        <InputMask
                                                          mask="99/99/9999"
                                                          value={
                                                            selectedDateEntree
                                                          }
                                                          className="form-control form-control-sm shadow-sm border-0 input-color"
                                                          onChange={
                                                            handleDateEntreeChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                          }}
                                                        />
                                                        <FiCalendar
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Actif* */}
                                              {key === "Actif" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Actif
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Actif"
                                                        value={
                                                          selectedActif?.label ==
                                                          null
                                                            ? null
                                                            : selectedActif
                                                        }
                                                        onChange={
                                                          handleActifChange
                                                        }
                                                        options={renderOuiNonOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedActif == null
                                                        )}
                                                        isDisabled={
                                                          type_compte ===
                                                          "partenaire_premium"
                                                        }
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                      {selectedActif ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Actif ne peut pas être
                                                          vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Défaut */}
                                              {key === "Défaut" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Défaut
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Défaut"
                                                        value={
                                                          selectedDefaut?.label ==
                                                          null
                                                            ? null
                                                            : selectedDefaut
                                                        }
                                                        onChange={
                                                          handleDefautChange
                                                        }
                                                        options={renderOuiNonOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Trigramme */}
                                              {key === "Trigramme" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Trigramme
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedTrigramme
                                                        }
                                                        required
                                                        onChange={
                                                          handleTrigrammeChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Tête de réseau* */}
                                              {key === "Tête de réseau" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Tête de réseau
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Tête de réseau"
                                                        value={
                                                          selectedTeteReseau?.label ==
                                                          null
                                                            ? null
                                                            : selectedTeteReseau
                                                        }
                                                        onChange={
                                                          handleTeteReseauChange
                                                        }
                                                        options={renderTeteReseauOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedTeteReseau ==
                                                            null
                                                        )}
                                                        isDisabled={
                                                          type_compte ===
                                                          "partenaire_premium"
                                                        }
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                      {selectedTeteReseau ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Tête de réseau ne peut
                                                          pas être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                              <Col sm="6">
                                {DonneesComplementData ? (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{
                                      borderRadius: "12px",
                                      display:
                                        DonneesComplementData.length >= 0
                                          ? "none"
                                          : "",
                                    }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleDonneesComplementAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Données complémentaires CGP
                                        </span>
                                      </div>
                                      {isDonneesComplementAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={isDonneesComplementAccordionOpen}
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            DonneesComplementData
                                          ).map(([key, value], index) => (
                                            <React.Fragment key={index}>
                                              {/* Email de contact */}
                                              {key === "Email de contact" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Email de contact
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedEmailDeContact
                                                        }
                                                        onChange={
                                                          handleEmailDeContactChange
                                                        }
                                                        type="email"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Origine */}
                                              {key === "Origine" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Origine
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedOrigine}
                                                        required
                                                        onChange={
                                                          handleOrigineChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Taux d'apport (restriction) */}
                                              {key ===
                                                "Taux d'apport (restriction)" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Taux d&apos;apport
                                                          (restriction)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Taux"
                                                        value={selectedTaux}
                                                        onChange={
                                                          handleTauxChange
                                                        }
                                                        options={renderTauxOptions()}
                                                        isClearable={true}
                                                        isMulti={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Modèle dossier de souscription */}
                                              {key ===
                                                "Modèle dossier de souscription" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Modèle dossier de
                                                          souscription
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Modèle"
                                                        value={
                                                          selectedModele?.label ==
                                                          null
                                                            ? null
                                                            : selectedModele
                                                        }
                                                        onChange={
                                                          handleModeleChange
                                                        }
                                                        options={renderModeleOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Modèle dossier de souscription TEPA */}
                                              {key ===
                                                "Modèle dossier de souscription TEPA" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Modèle dossier de
                                                          souscription TEPA
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Modèle"
                                                        value={
                                                          selectedModeleT?.label ==
                                                          null
                                                            ? null
                                                            : selectedModeleT
                                                        }
                                                        onChange={
                                                          handleModeleTChange
                                                        }
                                                        options={renderModeleOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Entrepreteurs */}
                                              {key === "Entrepreteurs" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Entrepreteurs
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        placeholder="Séléctionner Entrepreteurs"
                                                        value={
                                                          selectedEntrepreteur?.label ==
                                                          null
                                                            ? null
                                                            : selectedEntrepreteur
                                                        }
                                                        onChange={
                                                          handleEntrepreteurChange
                                                        }
                                                        options={renderOuiNonOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}
                                            </React.Fragment>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                ) : null}

                                <Row>
                                  <Col
                                    sm="12"
                                    style={{
                                      display:
                                        DonneesComplementDirectionData.length >=
                                        0
                                          ? "none"
                                          : "",
                                    }}
                                  >
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={
                                          toggleDonneesDirectionAccordion
                                        }
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Données complémentaires Direction
                                            produit
                                          </span>
                                        </div>
                                        {isDonneesDirectionAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isDonneesDirectionAccordionOpen}
                                      >
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {Object.entries(
                                              DonneesComplementDirectionData
                                            )?.map(([key, value], index) => (
                                              <React.Fragment key={index}>
                                                {/* Compte de créance */}
                                                {key ===
                                                  "Compte de créance" && (
                                                  <div
                                                    className="field-item px-2 py-1"
                                                    style={{
                                                      backgroundColor: "white",
                                                      transition:
                                                        "all 0.15s ease",
                                                      borderLeft:
                                                        "3px solid transparent",
                                                      marginBottom: "1px",
                                                      position: "relative",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#e3f2fd";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#007bff";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "white";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "transparent";
                                                    }}
                                                  >
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            Compte de créance
                                                          </span>
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col xs={12} md={8}>
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={
                                                            selectedCompteCreance
                                                          }
                                                          required
                                                          onChange={
                                                            handleCompteCreanceChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                )}

                                                {/* Code d'investissement par défaut */}
                                                {key ===
                                                  "Code d'investissement par défaut" && (
                                                  <div
                                                    className="field-item px-2 py-1"
                                                    style={{
                                                      backgroundColor: "white",
                                                      transition:
                                                        "all 0.15s ease",
                                                      borderLeft:
                                                        "3px solid transparent",
                                                      marginBottom: "1px",
                                                      position: "relative",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#e3f2fd";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#007bff";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "white";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "transparent";
                                                    }}
                                                  >
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            Code
                                                            d&apos;investissement
                                                            par défaut
                                                          </span>
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col xs={12} md={8}>
                                                        <Select
                                                          placeholder="Séléctionner Code"
                                                          value={
                                                            selectedCodeInves?.label ==
                                                            null
                                                              ? null
                                                              : selectedCodeInves
                                                          }
                                                          onChange={
                                                            handleCodeInvesChange
                                                          }
                                                          options={renderCodeOptions()}
                                                          isClearable={true}
                                                          classNamePrefix="select2-selection"
                                                          styles={styles(false)}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                        />
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                )}
                                              </React.Fragment>
                                            ))}
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </Col>
                                </Row>
                                {Object.keys(DonneesComplementExploitantData)
                                  .length > 0 ? (
                                  <Row>
                                    <Col sm="12">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden mb-4"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En-tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={
                                            toggleDonneesExploitantAccordion
                                          }
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Données complémentaires exploitant
                                            </span>
                                          </div>
                                          {isDonneesExploitantAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        <Collapse
                                          isOpen={
                                            isDonneesExploitantAccordionOpen
                                          }
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {Object.entries(
                                                DonneesComplementExploitantData
                                              ).map(([key, value], index) => (
                                                <React.Fragment key={index}>
                                                  {/* Matériel d'exploitation */}
                                                  {key ===
                                                    "Matériel d'exploitation" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Matériel
                                                              d&apos;exploitation
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={selectedMat}
                                                            required
                                                            onChange={
                                                              handleMatChange
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Comptable (conditionnel avec false) */}
                                                  {key === "Comptable" &&
                                                    false && (
                                                      <div
                                                        className="field-item px-2 py-1"
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          transition:
                                                            "all 0.15s ease",
                                                          borderLeft:
                                                            "3px solid transparent",
                                                          marginBottom: "1px",
                                                          position: "relative",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }}
                                                      >
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                }}
                                                              >
                                                                Comptable
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col xs={12} md={8}>
                                                            <Select
                                                              placeholder="Sélection du comptable"
                                                              value={
                                                                selectedComptable?.label ==
                                                                null
                                                                  ? null
                                                                  : selectedComptable
                                                              }
                                                              onChange={
                                                                handleComptableChange
                                                              }
                                                              options={renderContactOptions()}
                                                              isClearable={true}
                                                              classNamePrefix="select2-selection"
                                                              styles={styles(
                                                                false
                                                              )}
                                                              menuPortalTarget={
                                                                document.body
                                                              }
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}

                                                  {/* Date création activité */}
                                                  {key ===
                                                    "Date création activité" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Date création
                                                              activité
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <div className="input-wrapper position-relative">
                                                            <InputMask
                                                              mask="99/99/9999"
                                                              value={
                                                                selectedDataCrea
                                                              }
                                                              className="form-control form-control-sm shadow-sm border-0 input-color"
                                                              onChange={
                                                                handleDataCreaChange
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 2rem 0.375rem 0.5rem",
                                                                height: "32px",
                                                                transition:
                                                                  "all 0.2s ease",
                                                              }}
                                                            />
                                                            <FiCalendar
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Types de production */}
                                                  {key ===
                                                    "Types de production" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Types de
                                                              production
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <Select
                                                            placeholder="Séléctionner Type de production"
                                                            value={
                                                              selectedTypeProduction?.label ==
                                                              null
                                                                ? null
                                                                : selectedTypeProduction
                                                            }
                                                            onChange={
                                                              handleTypeProductionChange
                                                            }
                                                            options={renderTypeProductionOptions()}
                                                            isClearable={true}
                                                            isMulti={true}
                                                            classNamePrefix="select2-selection"
                                                            styles={styles(
                                                              false
                                                            )}
                                                            menuPortalTarget={
                                                              document.body
                                                            }
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Secteur d'activité de l'exploitant */}
                                                  {key ===
                                                    "Secteur d'activité de l'exploitant" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Secteur
                                                              d&apos;activité de
                                                              l&apos;exploitant
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedSecteur
                                                            }
                                                            required
                                                            onChange={
                                                              handleSecteurChange
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Secteur d'activité */}
                                                  {key ===
                                                    "Secteur d'activité" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Secteur
                                                              d&apos;activité
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <Select
                                                            key={forceRender3}
                                                            placeholder="Séléctionner"
                                                            value={
                                                              selectedSecteurActivite?.label ==
                                                              null
                                                                ? null
                                                                : selectedSecteurActivite
                                                            }
                                                            onChange={
                                                              handleSecteurActiviteChange
                                                            }
                                                            options={renderSecteurActiviteOptions()}
                                                            isClearable={true}
                                                            classNamePrefix="select2-selection"
                                                            styles={styles(
                                                              false
                                                            )}
                                                            menuPortalTarget={
                                                              document.body
                                                            }
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Surface construite (m²) */}
                                                  {key ===
                                                    "Surface construite (m²)" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Surface construite
                                                              (m²)
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedSurfaceCons
                                                            }
                                                            required
                                                            onChange={
                                                              handleSurfaceConsChange
                                                            }
                                                            type="number"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Surface exploitée (ha) */}
                                                  {key ===
                                                    "Surface exploitée (ha)" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Surface exploitée
                                                              (ha)
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedSurfaceExp
                                                            }
                                                            required
                                                            onChange={
                                                              handleSurfaceExpChange
                                                            }
                                                            type="number"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Surface totale détenue (ha) */}
                                                  {key ===
                                                    "Surface totale détenue (ha)" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Surface totale
                                                              détenue (ha)
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedSurfaceTot
                                                            }
                                                            required
                                                            onChange={
                                                              handleSurfaceTotChange
                                                            }
                                                            type="number"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}

                                                  {/* Impact sur l'emploi */}
                                                  {key ===
                                                    "Impact sur l'emploi" && (
                                                    <div
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft:
                                                          "3px solid transparent",
                                                        marginBottom: "1px",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#e3f2fd";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "#007bff";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        e.currentTarget.style.borderLeftColor =
                                                          "transparent";
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              Impact sur
                                                              l&apos;emploi
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedImpact
                                                            }
                                                            required
                                                            onChange={
                                                              handleImpactChange
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  )}
                                                </React.Fragment>
                                              ))}
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>
                                  </Row>
                                ) : null}
                              </Col>
                              <Col sm="12">
                                {hmfData1 ? (
                                  <>
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={
                                          toggleDonneesFinanciereAccordion
                                        }
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Données financières exploitant
                                          </span>
                                        </div>
                                        {isDonneesFinanciereAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={
                                          isDonneesFinanciereAccordionOpen
                                        }
                                      >
                                        <CardBody>
                                          <Col sm="12">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered rounded-3 overflow-hidden"
                                                style={{
                                                  borderCollapse: "collapse",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {hmfData1?.header?.map(
                                                      (columnName, index) => (
                                                        <th
                                                          className=""
                                                          style={tableaustyles}
                                                          key={index}
                                                        >
                                                          {columnName}
                                                        </th>
                                                      )
                                                    )}
                                                    <th
                                                      className=""
                                                      style={{
                                                        background: "#555B21",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                        width: "1%",
                                                      }}
                                                      key="Del"
                                                    ></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {formDonneesFinanciere &&
                                                    formDonneesFinanciere?.map(
                                                      (rowData) => (
                                                        <tr key={rowData.index}>
                                                          {Object.entries(
                                                            rowData
                                                          ).map(
                                                            ([key, value]) =>
                                                              key !== "id" &&
                                                              key !==
                                                                "index" ? (
                                                                <td key={key}>
                                                                  {key ===
                                                                  "annee_id" ? (
                                                                    <select
                                                                      value={
                                                                        value
                                                                      }
                                                                      name="annee_id"
                                                                      className="form-control form-control-sm"
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleInputFinanceChange(
                                                                          rowData.index,
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    >
                                                                      {renderAnneeOptions()}
                                                                    </select>
                                                                  ) : key ===
                                                                    "capitaux_propres" ? (
                                                                    <input
                                                                      className="form-control form-control-sm"
                                                                      type="number"
                                                                      step="0.1"
                                                                      defaultValue={
                                                                        value
                                                                      }
                                                                      name={key}
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleInputFinanceChange(
                                                                          rowData.index,
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    />
                                                                  ) : key ===
                                                                    "produits_exploitation" ? (
                                                                    <input
                                                                      className="form-control form-control-sm"
                                                                      type="number"
                                                                      step="0.1"
                                                                      defaultValue={
                                                                        value
                                                                      }
                                                                      name={key}
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleInputFinanceChange(
                                                                          rowData.index,
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    />
                                                                  ) : key ===
                                                                    "charges_exploitation" ? (
                                                                    <input
                                                                      className="form-control form-control-sm"
                                                                      type="number"
                                                                      step="0.1"
                                                                      defaultValue={
                                                                        value
                                                                      }
                                                                      name={key}
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleInputFinanceChange(
                                                                          rowData.index,
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    />
                                                                  ) : key ===
                                                                    "resultat_exploitation" ? (
                                                                    <input
                                                                      className="form-control form-control-sm"
                                                                      type="number"
                                                                      step="0.1"
                                                                      defaultValue={
                                                                        value
                                                                      }
                                                                      name={key}
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleInputFinanceChange(
                                                                          rowData.index,
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    />
                                                                  ) : (
                                                                    <span>
                                                                      {value}
                                                                    </span>
                                                                  )}
                                                                </td>
                                                              ) : (
                                                                <td
                                                                  className="d-none"
                                                                  key={key}
                                                                >
                                                                  <input
                                                                    type="hidden"
                                                                    value={
                                                                      value
                                                                    }
                                                                  />
                                                                </td>
                                                              )
                                                          )}
                                                          <td>
                                                            <i
                                                              className="bx bx-trash"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                                paddingTop:
                                                                  "5px",
                                                                textAlign:
                                                                  "center",
                                                                verticalAlign:
                                                                  "middle",
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() =>
                                                                onDeleteFormDonneesFinanciere(
                                                                  rowData.index
                                                                )
                                                              }
                                                            ></i>
                                                          </td>
                                                        </tr>
                                                      )
                                                    )}
                                                  <tr>
                                                    <td colSpan="9">
                                                      <input
                                                        type="button"
                                                        style={tableaustyles}
                                                        className="btn btn-info mt-3 mt-lg-0"
                                                        value="Ajouter"
                                                        onClick={
                                                          onAddFormDonneesFinanciere
                                                        }
                                                      />
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </Col>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                              <Col sm="12">
                                {hmfData2 ? (
                                  <>
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleDonneesInvestAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Données autres investissements
                                          </span>
                                        </div>
                                        {isDonneesInvestAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isDonneesInvestAccordionOpen}
                                      >
                                        <CardBody>
                                          <Col sm="12">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered rounded-3 overflow-hidden"
                                                style={{
                                                  borderCollapse: "collapse",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {hmfData2.header.map(
                                                      (columnName, index) => (
                                                        <th
                                                          className=""
                                                          style={tableaustyles}
                                                          key={index}
                                                        >
                                                          {columnName}
                                                        </th>
                                                      )
                                                    )}
                                                    <th
                                                      className=""
                                                      style={{
                                                        background: "#555B21",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                        width: "1%",
                                                      }}
                                                      key="Del"
                                                    ></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {formDonneesInvest.map(
                                                    (rowData) => (
                                                      <tr key={rowData.index}>
                                                        {Object.entries(
                                                          rowData
                                                        ).map(([key, value]) =>
                                                          key !== "id" &&
                                                          key !== "index" ? (
                                                            <td key={key}>
                                                              {key ===
                                                              "annee_id" ? (
                                                                <select
                                                                  value={value}
                                                                  name="annee_id"
                                                                  className="form-control form-control-sm"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputInvestChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                >
                                                                  {renderAnneeOptions()}
                                                                </select>
                                                              ) : key ===
                                                                "monteur" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  type="text"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputInvestChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : key ===
                                                                "base_eligible" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  type="number"
                                                                  step="0.1"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputInvestChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : key ===
                                                                "designation" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  type="text"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputInvestChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <span>
                                                                  {value}
                                                                </span>
                                                              )}
                                                            </td>
                                                          ) : (
                                                            <td
                                                              className="d-none"
                                                              key={key}
                                                            >
                                                              <input
                                                                type="hidden"
                                                                value={value}
                                                              />
                                                            </td>
                                                          )
                                                        )}
                                                        <td>
                                                          <i
                                                            className="bx bx-trash"
                                                            style={{
                                                              fontSize: "20px",
                                                              paddingTop: "5px",
                                                              textAlign:
                                                                "center",
                                                              verticalAlign:
                                                                "middle",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              onDeleteFormDonneesInvest(
                                                                rowData.index
                                                              )
                                                            }
                                                          ></i>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                  <tr>
                                                    <td colSpan="9">
                                                      <input
                                                        type="button"
                                                        style={tableaustyles}
                                                        className="btn btn-info mt-3 mt-lg-0"
                                                        value="Ajouter"
                                                        onClick={
                                                          onAddFormDonneesInvest
                                                        }
                                                      />
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </Col>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
